import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/Documents/Github/cp4d-managed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const Row = makeShortcode("Row");
const SquareCard = makeShortcode("SquareCard");
const Tools = makeShortcode("Tools");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The `}<a parentName="p" {...{
          "href": "https://www.ibm.com/products/expertlabs/managed-services"
        }}>{`IBM Expert Labs - Managed Services`}</a>{` brings the hands-on skills and deep expertise of IBM Essential Management to your business, when and where you need it.`}</p>
    </PageDescription>
    <h2>{`Who? How? What?`}</h2>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink"> WHO we are? </AnchorLink>
  <AnchorLink mdxType="AnchorLink"> HOW it works? </AnchorLink>
  <AnchorLink mdxType="AnchorLink"> WHAT we offer? </AnchorLink>
  <AnchorLink mdxType="AnchorLink">Video</AnchorLink>
    </AnchorLinks>
    <h2>{`Who we are?`}</h2>
    <p>{`IBM® Essential Management is a managed services offering from IBM Expert Labs that provides access to product experts who manage your IBM software and applications. Our industry-leading team specializes in timely, high quality delivery to ensure your enterprise remains on track for success. When our experts manage your software, you get instant access to top talent and outcomes without the need to worry about execution.`}</p>
    <h2>{`How it works?`}</h2>
    <Accordion mdxType="Accordion">
  <AccordionItem title="Access technological expertiser" mdxType="AccordionItem">IBM Essential Management provides a direct connection to specialists with deep knowledge of IBM software and applications.</AccordionItem>
  <AccordionItem title="Leverage industry best practices" mdxType="AccordionItem">We bring IBM Expert Labs’ best practices into the day-to-day management of your environment, allowing you to be confident in our proven experience.</AccordionItem>
  <AccordionItem title="Proactively manage capacity" mdxType="AccordionItem">Our experts help you identify how your planned growth and expansion could impact your available capacity, and we provide guidance on how to ensure satisfactory performance and stability post-deployment.</AccordionItem>
  <AccordionItem title="Stabilize working environments" mdxType="AccordionItem">We keep your team and technology on track to help deliver stability and consistent performance.</AccordionItem>
    </Accordion>
    <h2>{`What we offer?`}</h2>
    <Tabs mdxType="Tabs">
      <Tab label="Expert operations" mdxType="Tab">
We bring IBM Expert Labs’ best practices into the day-to-day management of your environment, allowing you to be confident in our proven experience.
      </Tab>
      <Tab label="Expert administration" mdxType="Tab">
Manage data, deployments, and processes with precision.
      </Tab>
      <Tab label="Expert advice" mdxType="Tab">
Tap into expertise honed from years of practical experience
      </Tab>
    </Tabs>
    <Tabs mdxType="Tabs">
      <Tab label="Optimize performance" mdxType="Tab">
Achieve accelerated results with a seamless end-to-end approach.
      </Tab>
      <Tab label="Mitigate IT risk" mdxType="Tab">
Design and deploy applications without unnecessary disruption.
      </Tab>
      <Tab label="Avoid known issues" mdxType="Tab">
Maintain steady state operations with the guidance of experts in your field.
      </Tab>
      <Tab label="Focus on innovation" mdxType="Tab">
Let us handle the technology so you can focus on strategic priorities.
      </Tab>
    </Tabs>
    <h2>{`Video`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=LToO1p8Gs8E"
      }}><img parentName="a" {...{
          "src": "https://img.youtube.com/vi/LToO1p8Gs8E/0.jpg",
          "alt": "Expert Labs"
        }}></img></a>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=oHBrbVf9VBY"
      }}><img parentName="a" {...{
          "src": "https://img.youtube.com/vi/oHBrbVf9VBY/0.jpg",
          "alt": "What is Cloud Pak?"
        }}></img></a></p>
    <Row className="square-card-group" mdxType="Row">
  <SquareCard title="The IBM Expert Labs" href="https://www.ibm.com/products/expertlabs/managed-services" mdxType="SquareCard">
    <Tools aria-label="Tools" className="my-custom-class" mdxType="Tools" />
  </SquareCard>
  <SquareCard title="IBM Expert Labs" href="https://www.ibm.com/it-infrastructure/us-en/resources/campaignmail/mail/Data-and-AI-Expert-Labs" bodyText="Contact Us" mdxType="SquareCard" />
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      